import { combineReducers } from 'redux';

import craReviewReducer from './craReview';
import smWorklistReducer from './smWorklist';

export default combineReducers({
  craReview: craReviewReducer,
  smWorklist: smWorklistReducer
});
